export class DialogModelCaCollection {
    constructor(
      public invoiceDetails: any
    ) {}
  }
  